import React from "react";
import { Route } from "react-router-dom";

import {OrdersUIProvider} from "../../contexts/OrdersUIContext";
import {OrdersContainer} from '../../components/containers/OrdersContainer';
import {OrderDetailModal} from "../../components/modules/OrderDetailModal";

import {URLs} from "../../../utils/routes";

export function OrdersPage({ history }) {
  const UIEvents = {
    openOrderDetailDialog: (id) => {
      history.push(`${URLs.SALES_ORDERS}/${id}`);
    },
  };

  return (
    <>
      <OrdersUIProvider UIEvents={UIEvents}>
        <OrdersContainer />
      </OrdersUIProvider>

      <Route path={URLs.SALES_ORDER_DETAIL}>
        {({ history, match }) => match ? (
          <OrderDetailModal
            show={true}
            onHide={() => history.goBack()}
            orderId={match.params.orderId}
          />
        ) : null}
      </Route>
    </>
  );
}
